import { defineMessages } from "react-intl";

import ClassificationMethod from "@app/scene/map/store/layers/boundaries/types/ClassificationMethod";
import DataSource from "@app/scene/map/store/layers/boundaries/types/DataSource";

export const messages = defineMessages({
  buckets: {
    id: "map.layer.boundaries.demography.edit.buckets",
    defaultMessage: "Number of buckets",
    description: "Number of buckets label",
  },
  classificationMethod: {
    id: "map.layer.boundaries.demography.edit.classificationMethod",
    defaultMessage: "Classification Method",
    description: "Classification Method label",
  },
  [ClassificationMethod.EQUAL_INTERVAL]: {
    id: "map.layer.boundaries.demography.edit.equalInterval.description",
    defaultMessage:
      "Groups data equally for clearer visualization and comparison. Ideal for looking at how big things are compared to each other. Less effective if the data is clustered on one end or if you're trying to spot outliers.",
    description: "Description - Equal Interval",
  },
  [ClassificationMethod.NATURAL_BREAKS]: {
    id: "map.layer.boundaries.demography.edit.naturalBreaks.description",
    defaultMessage:
      "Identifies natural data clusters to group similar items together. Most effective with unevenly distributed data. Avoids direct comparisons between different datasets due to unique group divisions.",
    description: "Description - Natural Breaks",
  },
  [ClassificationMethod.QUANTILE]: {
    id: "map.layer.boundaries.demography.edit.quantile.description",
    defaultMessage:
      "Divides data into equal-sized groups, optimal for evenly distributed data. Uneven distribution may obscure clear comparisons between groups.",
    description: "Description - Quantile",
  },
  colorBy: {
    id: "map.layer.boundaries.demography.edit.colorBy",
    defaultMessage: "Color by",
    description: "Color by label",
  },
  country: {
    id: "map.layer.boundaries.demography.edit.country",
    defaultMessage: "Country",
    description: "Country label",
  },
  dataSource: {
    id: "map.layer.boundaries.demography.edit.dataSource",
    defaultMessage: "Data Source",
    description: "Data Source label",
  },
  [DataSource.MEDIAN_INCOME]: {
    id: "map.layer.boundaries.demography.edit.medianIncome",
    defaultMessage: "Median Income ({dataSource})",
    description: "Title - Median Income",
  },
  [DataSource.POPULATION]: {
    id: "map.layer.boundaries.demography.edit.population",
    defaultMessage: "Population ({dataSource})",
    description: "Title - Population",
  },
  entire: {
    id: "map.layer.boundaries.demography.edit.entire",
    defaultMessage: "Entire data set",
    description: "Entire data set label",
  },
  entireSetDescription: {
    id: "map.layer.boundaries.demography.edit.entireSetDescription",
    defaultMessage:
      "Map areas will be colored based on how they compare to the entire set of data. This provides a consistent experience as you zoom in and out.",
    description: "Description for Color by Entire data set",
  },
  onlyVisible: {
    id: "map.layer.boundaries.demography.edit.onlyVisible",
    defaultMessage: "What’s visible",
    description: "What’s visible label",
  },
  preferences: {
    id: "map.layer.boundaries.demography.edit.preferences",
    defaultMessage: "Preferences",
    description: "Preferences label",
  },
  preview: {
    id: "map.layer.boundaries.demography.edit.preview",
    defaultMessage: "Preview of key ",
    description: "Preview of key label",
  },
  theme: {
    id: "map.layer.boundaries.demography.edit.theme",
    defaultMessage: "Theme",
    description: "Theme label",
  },
  title: {
    id: "map.layer.boundaries.demography.edit.title",
    defaultMessage: "Edit Demographic Data",
    description: "Edit Heat Map panel title on the Map page",
  },
  whatsVisibleDescription: {
    id: "map.layer.boundaries.demography.edit.whatsVisibleDescription",
    defaultMessage:
      "Map areas will be colored by only what is visible in the map, making it easier to detect smaller differences between areas in your map view.",
    description: "Description for What's visible coloring",
  },
});
